import dayjs from "dayjs";
import {
  dayMonthBasedLabel,
  getLabelsForCurrentMonth,
  getLabelsForCurrentWeek,
  getLabelsForLast12Months,
  getLabelsForLast30Day,
  getLabelsForLast3Months,
  getLabelsForLast6Months,
  getLabelsForLast7Days,
  getLabelsForYear,
  isPastTime,
  isTodayDate,
  monthBasedLabel,
  monthBasedLabelWithYear,
  timeBasedLabel,
  timeLabelForCharts,
} from "../../utils/utils";
import { colorBrandObject } from "../../../../constants/brandings";

export const refundValueCountChartSchema = (
  chartTransactionOverAll,
  selectedDropdownValue,
  locale,
  singleStartDate,
  startDate,
  endDate
) => {
  let labels = [];
  let chartData = [];
  let volumeData = [];

  const currentTime = new Date();
  const currentHour = currentTime.getHours();
  const currentMinute = currentTime.getMinutes();

  switch (selectedDropdownValue) {
    case "yesterday":
      const getLabelForYesterday = timeLabelForCharts();
      for (let i = 0; i < getLabelForYesterday.length; i++) {
        const dataPoint = getLabelForYesterday[i];
        labels.push(dataPoint);
      }
      labels.forEach((dataPoint) => {
        const dataItems = chartTransactionOverAll?.filter((item) => {
          return dataPoint.match(timeBasedLabel(item?.timestamp));
        });
        const refundCountPercentItem = dataItems.find(
          (item) => item?.refundCountPercent !== undefined
        );
        const refundCountLocaleItem = dataItems.find(
          (item) => item?.refundCountLocale !== undefined
        );
        chartData.push(
          refundCountPercentItem
            ? refundCountPercentItem?.refundCountPercent
            : 0
        );
        volumeData.push(
          refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0
        );
      });
      break;

    case "today":
      const getLabel = timeLabelForCharts();
      for (let i = 0; i < getLabel.length; i++) {
        const dataPoint = getLabel[i];
        labels.push(dataPoint);
      }
      labels.forEach((dataPoint) => {
        const pastTime = isPastTime(dataPoint, currentHour, currentMinute);
        if (pastTime) {
          const dataItems = chartTransactionOverAll?.filter((item) => {
            return dataPoint.match(timeBasedLabel(item?.timestamp));
          });
          const refundCountPercentItem = dataItems.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = dataItems.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(
            refundCountPercentItem
              ? refundCountPercentItem?.refundCountPercent
              : 0
          );
          volumeData.push(
            refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0
          );
        } else {
          chartData.push(null);
          volumeData.push(null);
        }
      });
      break;

    case "thisWeek":
      const getLabelForThisWeek = getLabelsForCurrentWeek();
      for (let i = 0; i < getLabelForThisWeek.length; i++) {
        const dataPoint = getLabelForThisWeek[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const dataPointDate = dayjs(dataPoint, "DD MMM");
          if (
            dataPointDate.isBefore(dayjs(), "day") ||
            dataPointDate.isSame(dayjs(), "day")
          ) {
            const chartDataItem = chartTransactionOverAll.filter((item) => {
              return dataPoint === dayMonthBasedLabel(item?.timestamp);
            });
            const refundCountPercentItem = chartDataItem.find(
              (item) => item?.refundCountPercent !== undefined
            );
            const refundCountLocaleItem = chartDataItem.find(
              (item) => item?.refundCountLocale !== undefined
            );
            chartData.push(
              refundCountPercentItem
                ? refundCountPercentItem?.refundCountPercent
                : 0
            );
            volumeData.push(
              refundCountLocaleItem
                ? refundCountLocaleItem?.refundCountLocale
                : 0
            );
          } else {
            chartData.push(null);
            volumeData.push(null);
          }
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;
    case "lastWeek":
      const getLabelForWeek = getLabelsForLast7Days();
      for (let i = 0; i < getLabelForWeek.length; i++) {
        const dataPoint = getLabelForWeek[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll.filter((item) => {
            return dataPoint === dayMonthBasedLabel(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(
            refundCountPercentItem
              ? refundCountPercentItem?.refundCountPercent
              : 0
          );
          volumeData.push(
            refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0
          );
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;

    case "thisLastMonth":
      const getLabelForThisMonth = getLabelsForCurrentMonth();
      for (let i = 0; i < getLabelForThisMonth.length; i++) {
        const dataPoint = getLabelForThisMonth[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const dataPointDate = dayjs(dataPoint, "DD MMM");
          if (
            dataPointDate.isBefore(dayjs(), "day") ||
            dataPointDate.isSame(dayjs(), "day")
          ) {
            const chartDataItem = chartTransactionOverAll.filter((item) => {
              return dataPoint === dayMonthBasedLabel(item?.timestamp);
            });
            const refundCountPercentItem = chartDataItem.find(
              (item) => item?.refundCountPercent !== undefined
            );
            const refundCountLocaleItem = chartDataItem.find(
              (item) => item?.refundCountLocale !== undefined
            );

            chartData.push(
              refundCountPercentItem
                ? refundCountPercentItem?.refundCountPercent
                : 0
            );
            volumeData.push(
              refundCountLocaleItem
                ? refundCountLocaleItem?.refundCountLocale
                : 0
            );
          } else {
            chartData.push(null);
            volumeData.push(null);
          }
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;
    case "thisMonth":
      const getLabelForMonth = getLabelsForLast30Day();
      for (let i = 0; i < getLabelForMonth.length; i++) {
        const dataPoint = getLabelForMonth[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll.filter((item) => {
            return dataPoint === dayMonthBasedLabel(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(refundCountPercentItem ? refundCountPercentItem?.refundCountPercent : 0);
          volumeData.push(refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0);
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;



    case "last3Months":
      const getLabelForLast3Months = getLabelsForLast3Months();
      for (let i = 0; i < getLabelForLast3Months.length; i++) {
        const dataPoint = getLabelForLast3Months[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll.filter((item) => {
            return dataPoint === monthBasedLabelWithYear(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(refundCountPercentItem ? refundCountPercentItem?.refundCountPercent : 0);
          volumeData.push(refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0);
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;

    case "last6Months":
      const getLabelForLast6Months = getLabelsForLast6Months();
      for (let i = 0; i < getLabelForLast6Months.length; i++) {
        const dataPoint = getLabelForLast6Months[i];
        labels.push(dataPoint);
      }

      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll.filter((item) => {
            return dataPoint === monthBasedLabelWithYear(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(refundCountPercentItem ? refundCountPercentItem?.refundCountPercent : 0);
          volumeData.push(refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0);
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;

    case "last12Months":
      const getLabelForLast12Months = getLabelsForLast12Months();
      for (let i = 0; i < getLabelForLast12Months.length; i++) {
        const dataPoint = getLabelForLast12Months[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll.filter((item) => {
            return dataPoint === monthBasedLabelWithYear(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(refundCountPercentItem ? refundCountPercentItem?.refundCountPercent : 0);
          volumeData.push(refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0);
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;



    case "thisYear":
      const getLabelForYear = getLabelsForYear();
      for (let i = 0; i < getLabelForYear.length; i++) {
        const dataPoint = getLabelForYear[i];
        labels.push(dataPoint);
      }
      if (chartTransactionOverAll?.length > 0) {
        labels.forEach((dataPoint) => {
          const chartDataItem = chartTransactionOverAll?.filter((item) => {
            return dataPoint === monthBasedLabel(item?.timestamp);
          });
          const refundCountPercentItem = chartDataItem.find(
            (item) => item?.refundCountPercent !== undefined
          );
          const refundCountLocaleItem = chartDataItem.find(
            (item) => item?.refundCountLocale !== undefined
          );
          chartData.push(
            refundCountPercentItem
              ? refundCountPercentItem?.refundCountPercent
              : null
          );
          volumeData.push(
            refundCountLocaleItem ? refundCountLocaleItem?.refundCountLocale : 0
          );
        });
      } else {
        chartData.push(null);
        volumeData.push(null);
      }
      break;

    case "customDate":
      const startDateObj = dayjs(startDate);
      const endDateObj = dayjs(endDate);
      const dateDiff = endDateObj.diff(startDateObj, "day");

      if (startDate && endDate) {
        if (startDateObj.isSame(endDateObj, "day")) {
          // If startDate and endDate are the same, show time labels
          const getLabelForCustomDate = timeLabelForCharts();
          const isCurrentDay = isTodayDate(startDateObj);

          getLabelForCustomDate.forEach((dataPoint) => {
            labels.push(dataPoint);
          });

          labels.forEach((dataPoint) => {
            let pastTime = true;

            if (isCurrentDay) {
              const currentHour = dayjs().hour();
              const currentMinute = dayjs().minute();
              pastTime = isPastTime(dataPoint, currentHour, currentMinute);
            }

            if (pastTime) {
              const dataItems = chartTransactionOverAll?.filter((item) => {
                return dataPoint.match(timeBasedLabel(item?.timestamp));
              });
              const refundCountPercentItem = dataItems.find(
                (item) => item?.refundCountPercent !== undefined
              );
              const refundCountLocaleItem = dataItems.find(
                (item) => item?.refundCountLocale !== undefined
              );
              chartData.push(
                refundCountPercentItem
                  ? refundCountPercentItem?.refundCountPercent
                  : 0
              );
              volumeData.push(
                refundCountLocaleItem
                  ? refundCountLocaleItem?.refundCountLocale
                  : 0
              );
            } else {
              chartData.push(null);
              volumeData.push(null);
            }
          });
        } else if (dateDiff <= 62) {
          for (
            let date = startDateObj;
            date.isBefore(endDateObj) || date.isSame(endDateObj, "day");
            date = date.add(1, "day")
          ) {
            labels.push(date.format("DD MMM"));
          }
          labels.forEach((dataPoint) => {
            const dataPointDate = dayjs(dataPoint, "DD MMM");
            if (
              dataPointDate.isBefore(dayjs(), "day") ||
              dataPointDate.isSame(dayjs(), "day")
            ) {
              const chartDataItem = chartTransactionOverAll.filter((item) => {
                return dataPoint === dayMonthBasedLabel(item?.timestamp);
              });
              const refundCountPercentItem = chartDataItem.find(
                (item) => item?.refundCountPercent !== undefined
              );
              const refundCountLocaleItem = chartDataItem.find(
                (item) => item?.refundCountLocale !== undefined
              );
              chartData.push(
                refundCountPercentItem
                  ? refundCountPercentItem?.refundCountPercent
                  : 0
              );
              volumeData.push(
                refundCountLocaleItem
                  ? refundCountLocaleItem?.refundCountLocale
                  : 0
              );
            } else {
              chartData.push(null);
              volumeData.push(null);
            }
          });
        }
      } else if (singleStartDate) {
        const singleStartDateObj = dayjs(singleStartDate);
        const useCurrentTime = isTodayDate(singleStartDate);
        const getLabelForSingleDate = timeLabelForCharts();
        for (let i = 0; i < getLabelForSingleDate.length; i++) {
          const dataPoint = getLabelForSingleDate[i];
          labels.push(dataPoint);
        }
        labels.forEach((dataPoint) => {
          const comparisonTime = useCurrentTime
            ? dayjs() // Ensure this is a dayjs object
            : singleStartDateObj.endOf("day");
          const pastTime = isPastTime(
            dataPoint,
            comparisonTime.hour(),
            comparisonTime.minute()
          );
          if (pastTime) {
            const dataItems = chartTransactionOverAll?.filter((item) => {
              return dataPoint.match(timeBasedLabel(item?.timestamp));
            });
            const refundCountPercentItem = dataItems.find(
              (item) => item?.refundCountPercent !== undefined
            );
            const refundCountLocaleItem = dataItems.find(
              (item) => item?.refundCountLocale !== undefined
            );
            chartData.push(
              refundCountPercentItem
                ? refundCountPercentItem?.refundCountPercent
                : 0
            );
            volumeData.push(
              refundCountLocaleItem
                ? refundCountLocaleItem?.refundCountLocale
                : 0
            );
          } else {
            chartData.push(null);
            volumeData.push(null);
          }
        });
      }
      break;
    default:
      break;
  }

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Refund Count",
        data: volumeData,
        type: "bar",
        fill: false,
        borderColor: colorBrandObject?.barGraphColor,
        backgroundColor: colorBrandObject?.barGraphColor,
        pointBorderColor: colorBrandObject?.barGraphColor,
        pointBackgroundColor: colorBrandObject?.barGraphColor,
        pointHoverBackgroundColor: colorBrandObject?.barGraphColor,
        pointHoverBorderColor: colorBrandObject?.barGraphColor,
        yAxisID: "y1",
        order: 2,
      },
      {
        type: "line",
        label: "Refund Rate ",
        data: chartData,
        fill: false,
        backgroundColor: colorBrandObject?.lineGraphColor,
        borderColor: colorBrandObject?.lineGraphColor,
        hoverBackgroundColor: colorBrandObject?.lineGraphColor,
        hoverBorderColor: colorBrandObject?.lineGraphColor,
        yAxisID: "y",
        order: 1,
      },
    ],
  };

  const options = {
    font: {
      family: "Poppins",
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "",
          color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
          font: {
            family: "Poppins",
            size: "12px",
            fontSize: "12px",
            weight: "400",
          },
        },
        display: true,
        offset: true,
        grid: {
          display: false,
        },
        labels: data.labels,
      },
      y1: {
        beginAtZero: true,
        grid: {
          borderDash: [8, 6],
        },
        title: {
          display: true,
          text: "Count",
          color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
          font: {
            family: "Poppins",
            size: "12px",
            fontSize: "12px",
            style: "normal",
            weight: "400",
          },
        },
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          callback: (value) => {
            return locale === ""
              ? value
              : new Intl.NumberFormat(locale?.replace("_", "-"), {
                notation: "compact",
                compactDisplay: "short",
              })
                .format(value)
                .replace("T", "K");
          },
        },
        suggestedMax: Math.max(...volumeData) * 1.15,
      },
      y: {
        suggestedMin: 0,
        suggestedMax: 100,
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: "Percentage",
          color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
          font: {
            family: "Poppins",
            size: "12px",
            fontSize: "12px",
            style: "normal",
            weight: "400",
          },
        },
        type: "linear",
        display: true,
        position: "right",
        ticks: {
          callback: (value) => value + "%",
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          padding: 20,
          position: "right",
        },
      },
    },
  };
  return { data, options };
};
